import type { QuotaDocument } from "./quotas";
import type { Database, DocumentData } from ".";

export function quotasFromDocument(db: Database, data: DocumentData): QuotaDocument {
    return (db.convertFromDocument(data) as unknown) as QuotaDocument;
}
